import jQuery from "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "datatables.net";
import "datatables.net-dt";

import "@app/utils/polyfill-foreach";
import "@app/validation/greater-than";
import { SearchFilterComponent } from "@app/components/search/filter";
import { DataTableComponent } from "@app/components/data/table";
import { ModalContainerComponent } from './components/modal/container';
import { LoadingCoverComponent } from './components/common/loading-cover';
import { DataExportCsvComponent } from './components/data/export-csv';
import { SearchRequestModel } from './api/models/data';
import { DataClaimTotalComponent } from './components/data/claim-total';
import { FooterLinks } from "./components/common/footer";
import { MainNavigation } from "./components/common/header";
import { HamburgerToggle } from "./components/common/hamburger";
import ToggleExpandCard from "@app/utils/toggle-expand-card";
import ToggleFilterTrays from "@app/utils/toggle-filter-trays";

declare global {
    interface Window {
        $: JQueryStatic;
		jQuery: JQueryStatic;
		app: Function;
    }
}

window.jQuery = window.$ = jQuery;
$(document.body).toggleClass("no-js", false).toggleClass("js", true);

require("./../css/index.scss");
require('./missingImageFixer.js');
require('./civicCookieConfig.js');

window.app = function(page: string) {
	if (page === 'home') {

		const modalContainer = new ModalContainerComponent(document.querySelector(".modal-container") as HTMLElement);

		const filterComponent = new SearchFilterComponent(
			document.querySelector("form.search-filter") as HTMLFormElement,
			modalContainer);

		const tableContainerElement = document.querySelector(".search-results-container") as HTMLElement;
		const tableLoadingCoverComponent =
			new LoadingCoverComponent(
				tableContainerElement.querySelector(".search-results-container__loading-cover") as HTMLElement);

		const exportCsvComponent = 
			new DataExportCsvComponent(
				tableContainerElement.querySelector(".search-results-container__export-to-csv-button") as HTMLAnchorElement);
		const claimsTotalComponent =
			new DataClaimTotalComponent(
				tableContainerElement.querySelector(".search-results-container__total") as HTMLElement);

		const tableComponent =
			new DataTableComponent(tableContainerElement.querySelector("table.search-results") as HTMLTableElement);
		tableComponent.onLoading$.subscribe(() => {
			$(tableContainerElement).toggleClass("search-results-container__visible", true);
			tableLoadingCoverComponent.setVisibility(true);
		});
		tableComponent.onLoaded$.subscribe((sender, state) => {
			tableLoadingCoverComponent.setVisibility(false);

			if (state.success) {
				claimsTotalComponent.update(state.claimsTotal);
			}
		});
		tableComponent.onPreXhr$.subscribe((sender, data: SearchRequestModel) => {
			exportCsvComponent.update(data);
		});

		filterComponent.onSearch$.subscribe((_, searchFilterModel) => {
			tableComponent.setSearchFilterModel(searchFilterModel.searchFilter);
			tableComponent.reload();
		});

		var a = new ToggleFilterTrays(document.querySelector('.search-filter') as HTMLElement);

        document.addEventListener('DOMContentLoaded',
			() => {
				var filterForm = document.querySelector('.search-filter') as HTMLFormElement;
				if (filterForm != null) {
                    var submitButton = filterForm.querySelector('.button[type=submit]') as HTMLElement;
                    submitButton.click();
                }
            });
    }

	var footerLinks = new FooterLinks();
    document.documentElement.setAttribute("data-browser", navigator.userAgent);
	const mainNavigation = new MainNavigation();

        var hamburgerMainCategories = document.querySelectorAll(".site-hamburger__category");
        var hamburgerSubCategories = document.querySelectorAll(".hamburger-sub-categories__sub-category");

        const hamburgerToggle = new HamburgerToggle();

        for (let i = 0; i <= hamburgerMainCategories.length - 1; i++) {
            const hamburgerMainCategoriesToggle = new ToggleExpandCard(
                hamburgerMainCategories[i].querySelector(".site-hamburger__category-title-button") as HTMLElement,
                hamburgerMainCategories[i].querySelector(".hamburger__category-menu ") as HTMLElement,
                "inline"
            );
        }

        for (let i = 0; i <= hamburgerSubCategories.length - 1; i++) {
            const hamburgerSubCategoriesToggle = new ToggleExpandCard(
                hamburgerSubCategories[i].querySelector(".hamburger-sub-category__title--with-subCategories") as HTMLElement,
                hamburgerSubCategories[i].querySelector(".hamburger-sub-category__links ") as HTMLElement,
                "inline"
            );
        }
}